<template>
  <!-- 菜单管理 -->
  <div class="wrapper">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">
          <i class="el-icon-menu title-icon"></i>
          {{ $route.meta.name }}
        </h2>
        <div class="header-count">
          <span class="count-label">共</span>
          <span class="count-value">{{ total }}</span>
          <span class="count-label">条记录</span>
        </div>
      </div>
    </div>

    <!-- 表格区域 -->
    <el-card class="table-card" shadow="never">
      <div slot="header" class="card-header">
        <i class="el-icon-s-order"></i>
        <span>菜单列表</span>
        <el-button
            v-checkbtn="isShowBtn(AUTH_BTN.menu_list_add)"
            type="primary"
            size="small"
            class="add-btn"
            @click="goAddRootMenu"
        >
          <i class="el-icon-plus"></i>
          <span>新增</span>
        </el-button>
      </div>

      <el-table
          :data="list"
          row-key="id"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          :header-row-style="{ height: '50px', color: '#626e7c' }"
          :cell-style="changeTr"
          :header-cell-style="changeHeader"
          class="menu-table"
      >
        <el-table-column label="名称" align="left" width="300px">
          <template slot-scope="scope">
            {{ scope.row.menuName }}
          </template>
        </el-table-column>
        <el-table-column label="菜单类型" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.menuType == 1" type="success" class="menu-tag">目录</el-tag>
            <el-tag v-if="scope.row.menuType == 2" type="info" class="menu-tag">菜单</el-tag>
            <el-tag v-if="scope.row.menuType == 3" type="warning" class="menu-tag">按钮</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-link v-checkbtn="isShowBtn(AUTH_BTN.menu_list_add)" :underline="false" type="primary" class="action-link" @click="goAdd(scope.row)">新增</el-link>
            <el-link v-checkbtn="isShowBtn(AUTH_BTN.menu_list_edit)" :underline="false" style="margin:0 10px" type="primary" class="action-link" @click="goEdit(scope.row)">编辑</el-link>
            <el-link
                v-checkbtn="isShowBtn(AUTH_BTN.menu_list_del)"
                @click="apiDelMenu(scope.row.id)"
                :underline="false"
                style="margin-left:10px"
                type="danger"
                class="action-link"
            >
              删除
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 保存菜单 -->
    <el-dialog 
        :title="formTitle" 
        :visible.sync="dialogVisible" 
        width="600px" 
        class="menu-dialog"
    >
      <div class="scroll-wrap">
        <el-form ref="form" :model="formData" :rules="rules" label-width="130px" class="menu-dialog-form">
          <el-form-item label="上级菜单">
            <MenuTreeSelect ref="menuRef" v-model="formData.parentId" class="form-tree-select"></MenuTreeSelect>
          </el-form-item>
          <el-form-item label="名称" prop="menuName">
            <el-input v-model="formData.menuName" placeholder="请输入菜单名称" clearable class="form-input"></el-input>
          </el-form-item>
          <el-form-item label="菜单类型" prop="menuType">
            <el-select v-model="formData.menuType" clearable placeholder="请选择菜单类型" class="form-select">
              <el-option v-for="item in MENU_TYPE" :key="item.value" :label="item.name" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="路由标识" prop="routeCode">
            <el-input v-model="formData.routeCode" placeholder="请输入路由标识" clearable class="form-input"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input v-model="formData.sort" placeholder="请输入排序" clearable class="form-input"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">取 消</el-button>
        <el-button type="primary" @click="save" size="small">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getMenusTree, delMenu, getMenuDetail, editMenu, addMenu } from './api';
import { authBtnMixin } from '@/mixins/authBtnMixin';
import MenuTreeSelect from "./menu-tree-select.vue";
import { MENU_TYPE } from "@/enum/dict";

export default {
  name: 'SystemMenuList',
  components: {MenuTreeSelect},
  mixins: [authBtnMixin],
  data() {
    return {
      list: [],
      total: 0,
      dialogVisible: false,
      formTitle: '新增菜单',
      formData: {
        parentId: 0,
        menuName: '', //菜单名称
        menuType: '', //菜单类型
        routeCode: '', //路由标识
        // permCode: '', //权限标识
        sort: 1,
      },
      rules: {
        menuName: [
          { required: true, message: '菜单名称不能为空', trigger: 'blur' }
        ],
        menuType: [
          { required: true, message: '菜单类型不能为空', trigger: 'blur' }
        ],
        routeCode: [
          { required: true, message: '路由标识不能为空', trigger: 'blur' }
        ]
      },
      MENU_TYPE, //菜单类型
    }
  },
  provide() {
    return {
      context: this
    }
  },
  mounted() {
    this.apiQueryMenuTree();
  },
  methods: {
    async apiQueryMenuTree() {
      let res = await getMenusTree();
      this.list = res || [];
    },
    initFormData() {
      this.formData = {
        parentId: 0,
        menuName: '',
        menuType: '',
        routeCode: '',
        // permCode: '',
        sort: 1,
      };
    },
    // 新增一级菜单
    goAddRootMenu() {
      this.initFormData();
      this.dialogVisible = true;
    },
    // 新增子菜单
    goAdd(row) {
      const { id } = row;
      this.initFormData();
      this.formData.parentId = id;
      this.$nextTick(() => {
        this.$refs.menuRef.getMenusTree();
      });
      this.dialogVisible = true;
    },
    cancel() {
      this.dialogVisible = false;
    },
    async save() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          // formData中有menuId情况为编辑，无则为新增
          if (this.formData.id) {
            await editMenu(this.formData).then(() => {
              this.apiQueryMenuTree();
              this.$message.success('编辑成功');
              this.dialogVisible = false;
            })
          } else {
            if (this.formData.parentId > 0) {
              await addMenu(this.formData).then(() => {
                this.apiQueryMenuTree();
                this.$message.success('新增成功');
                this.dialogVisible = false;
              })
            } else {
              await addMenu(this.formData).then(() => {
                this.apiQueryMenuTree();
                this.$message.success('新增成功');
                this.dialogVisible = false;
              })
            }
          }
        } else {
          return false;
        }
      })
    },
    async apiQueryMenuDetail(id) {
      this.formData = await getMenuDetail({ id });
    },
    goEdit(row) {
      const { id } = row;
      this.formTitle = '编辑菜单';
      this.apiQueryMenuDetail(id);
      this.dialogVisible = true;
    },
    async apiDelMenu(id) {
      this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            delMenu(id).then(() => {
              this.apiQueryMenuTree();
              this.$message({ type: 'success', message: '操作成功!' });
            })
          })
          .catch(() => {})
    },
    // 修改第一列无children的样式
    changeTr({ row, column, rowIndex, columnIndex }) {
      if (!row.children && columnIndex == 0) {
        return { paddingLeft: '100px' };
      }
      if (columnIndex == 0) {
        return { paddingLeft: '100px' };
      }
    },
    changeHeader({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return { background: '#f8f9fb', padding: '8px 0 0 130px' };
      } else {
        return { background: '#f8f9fb', padding: '8px 0' };
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
  padding: 20px;
  min-height: calc(100vh - 84px);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
    pointer-events: none;
    z-index: 0;
  }
}

// 页面标题区域
.page-header {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
  }
  
  .page-title {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: #1a1e25;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: -0.5px;
    
    .title-icon {
      font-size: 28px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
  
  .header-count {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    
    .count-label {
      color: #909399;
    }
    
    .count-value {
      color: #409EFF;
      font-weight: 600;
      font-size: 18px;
    }
  }
}

// 表格卡片样式
.table-card {
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  .card-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    
    i {
      font-size: 18px;
      margin-right: 8px;
    }
    
    .add-btn {
      margin-left: auto;
      border-radius: 10px;
      padding: 8px 20px;
      font-weight: 600;
      font-size: 13px;
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;
      box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      letter-spacing: 0.3px;
      display: inline-flex;
      align-items: center;
      gap: 6px;

      &:hover:not(.is-disabled) {
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
        transform: translateY(-2px);
      }

      &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
      }
    }
  }

  ::v-deep .el-card__body {
    padding: 24px;
  }
  
  .menu-table {
    ::v-deep .el-table__header-wrapper {
      .el-table__header {
        th {
          background: linear-gradient(180deg, #f8f9fb 0%, #f0f2f5 100%);
          color: #303133;
          font-weight: 600;
          border-bottom: 2px solid #e4e7ed;
        }
      }
    }
    
    ::v-deep .el-table__body-wrapper {
      .el-table__body {
        tr {
          transition: all 0.3s ease;
          
          &:hover {
            background: rgba(64, 158, 255, 0.05);
          }
        }
      }
    }
    
    .menu-tag {
      border-radius: 12px;
      padding: 4px 12px;
      font-size: 12px;
      font-weight: 500;
      border: none;
    }
    
    .action-link {
      transition: all 0.3s ease;
      
      &:hover {
        opacity: 0.8;
        transform: translateY(-1px);
      }
    }
  }
}

// 对话框样式
.menu-dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    padding: 20px 24px;
    border-bottom: none;

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__close {
      color: #fff;
      font-size: 20px;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 24px;
    background: #f5f7fa;
  }

  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid #e4e7ed;
  }

  ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #606266;
    font-size: 14px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}

.scroll-wrap {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

.menu-dialog-form {
  .form-input {
    width: 100%;
    max-width: 400px;

    ::v-deep .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;
      text-align: left;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  .form-select {
    width: 100%;
    max-width: 400px;

    ::v-deep .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  .form-tree-select {
    width: 100%;
    max-width: 400px;

    ::v-deep .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .el-button {
    padding: 10px 24px;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.3s ease;

    &.el-button--primary {
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;

      &:hover {
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
        transform: translateY(-2px);
      }
    }

    &:not(.el-button--primary) {
      &:hover {
        color: #409EFF;
        border-color: #409EFF;
        background-color: #ecf5ff;
      }
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .wrapper {
    padding: 16px;
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 12px;
  }
  
  .page-header .header-content {
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    
    .page-title {
      font-size: 20px;
    }
  }
  
  .table-card {
    border-radius: 12px;
    
    ::v-deep .el-card__body {
      padding: 16px;
    }
  }
  
  .menu-dialog {
    ::v-deep .el-dialog {
      width: 95% !important;
      margin: 5vh auto !important;
    }
  }

  .menu-dialog-form {
    .form-input,
    .form-select,
    .form-tree-select {
      max-width: 100% !important;
    }
  }
}
</style>
